<div class="content">
    <div class="header">
        <div [ngClass]="['data', element.class]" *ngFor="let element of headers">{{element.name}}</div>
    </div>
    <div class="rows">
        <ng-content></ng-content>
    </div>
</div>